import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import {
  MODULES_KEY,
  PERMISSION_OBJECT,
  ROUTES_MODULES_KEY,
} from '../../common/constants';
import Holiday from './Holidays';
import './holidays.less';

const HolidaysWrapper = () => (
  <Switch>
    <Route
      exact
      path={`${ROUTES_MODULES_KEY?.HOLIDAYS}`}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.HOLIDAYS}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <Holiday {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);

export default HolidaysWrapper;
